type LogoProps = {
  className?: string;
};

/**
 * CIAM wordmark — "Ciam" set in Fraunces (the product's display serif), drawn
 * with the brand foreground token so it recolors with the theme. Matches the
 * wordmark used inside the product sidebar.
 */
export function Logo({ className }: LogoProps) {
  return (
    <span
      className={className}
      style={{
        fontFamily: "var(--font-fraunces)",
        fontWeight: 600,
        fontSize: "1.5rem",
        lineHeight: 1,
        letterSpacing: "-0.01em",
        color: "var(--foreground)",
      }}
    >
      Ciam
    </span>
  );
}
